'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import styles from './searchCorrectionNotice.module.scss';

interface SearchCorrectionNoticeProps {
  original: string;
  corrected: string;
}

const SearchCorrectionNotice: React.FC<SearchCorrectionNoticeProps> = ({ original, corrected }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  if (!original || !corrected || original.toLowerCase() === corrected.toLowerCase()) {
    return null;
  }

  // Clone and update query params
  const newParams = new URLSearchParams(searchParams.toString());
  newParams.set('q', original);
  newParams.set('force', 'true');

  const href = `${pathname}?${newParams.toString()}`;

  return (
    <div className={styles.notice}>
      <p>
        Showing results for <strong>{corrected}</strong>. Did you mean to search for{' '}
        <Link href={href}>
          “{original}”
        </Link>
        ?
      </p>
    </div>
  );
};

export default SearchCorrectionNotice;
